var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.subGroupContent),function(lineContent,index){return _c('div',{key:index,class:{ 'striped': _vm.striped }},[_vm._t("default",null,{"lineContent":lineContent})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }